import React from 'react'
import {DataGrid, GridCellParams, GridColDef} from '@mui/x-data-grid';

type SerialRows = {
    serial: string | null,
    expected: number,
    received: number,
    unexpected: number,
    missing: number
}
type NonSerialRows = {
    sku: string | null,
    expected: number,
    received: number,
    unexpected: number,
    missing: number
}

interface ReceiveSummaryTableProps {
    rows: SerialRows[] | NonSerialRows[],
    isSerial: boolean
}

const ReceiveSummaryTable = ({
    rows,
    isSerial
}: ReceiveSummaryTableProps) => {

    const columns: GridColDef[] = [
        {
            field: 'id',
            headerName: isSerial ? 'Serial' : 'Item',
            flex: 2,
            renderHeader: (params) => <strong>{params.colDef.headerName}</strong>,
            renderCell: (params: GridCellParams) => (
                <div style={{
                    color: getRowStyle(params.row),
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    maxWidth: '100%'
                }}>{params.row.serial || params.row.sku}
                </div>
            )
        },
        {
            field: 'expected',
            headerName: 'Expected',
            flex: 1,
            renderHeader: (params) => <strong>{params.colDef.headerName}</strong>,
            width: 130,
            renderCell: (params: GridCellParams) => (
                <div style={{color: getRowStyle(params.row)}}>{params.row.expected}</div>
            )
        },
        {
            field: 'received',
            flex: 1,
            renderHeader: (params) => <strong>{params.colDef.headerName}</strong>,
            headerName: 'Received',
            width: 130,
            renderCell: (params: GridCellParams) => (
                <div style={{color: getRowStyle(params.row)}}>{params.row.received}</div>
            )
        },
        {
            field: 'unexpected',
            headerName: 'Unexpected',
            flex: 1,
            renderHeader: (params) => <strong>{params.colDef.headerName}</strong>,
            width: 130,
            renderCell: (params: GridCellParams) => (
                <div style={{color: getRowStyle(params.row)}}>{params.row.unexpected}</div>
            )
        },
        {
            field: 'missing',
            headerName: 'Missing',
            flex: 1,
            renderHeader: (params) => <strong>{params.colDef.headerName}</strong>,
            width: 130,
            renderCell: (params: GridCellParams) => (
                <div style={{color: getRowStyle(params.row)}}>{params.row.missing}</div>
            )
        }
    ]
    const transformedRows = rows.map((item, index) => ({
        id: index, // Give each row a unique id
        serial: 'serial' in item ? item.serial : null,
        sku: 'sku' in item ? item.sku : null,
        expected: item.expected,
        received: item.received,
        unexpected: item.unexpected,
        missing: item.missing
    }))

    const getRowStyle = (row: any) => {

        if (row.unexpected > 0) {
            return '#ff7f00'
        }
        if (row.missing > 0) {
            return '#cc0000'
        }
        return '#000000'
    }

    return (
        <DataGrid
            rows={transformedRows}
            columns={columns}
            getRowClassName={getRowStyle}
        />
    )
}

export default ReceiveSummaryTable
